import { createApiConstants } from '@saucelabs/sl-util-redux';

const NAMESPACE = 'web-ui-auth';
const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const INITIALIZE = createApiNamespacedConstants('INITIALIZE');

export const CHANGE_EMAIL_MODAL = `${NAMESPACE}/CHANGE_EMAIL_MODAL`;
export const CHANGE_EMAIL_FORM = `${NAMESPACE}/CHANGE_EMAIL_FORM`;

export const LOGIN = `${NAMESPACE}/LOGIN`;
export const LOGIN_FORM = 'loginForm';
